/**
 * Gets the PRO statement work IDs from a list of work_ids.
 * On a ProTrack or trqkSong, the work_ids array consists of a list of IDs, each of which has a
 * format like:
 *      AS0369546120191P-891513172
 * The section before the dash is our internal ID for the user, and the section after the dash
 * is the "work ID" from the PRO statement.
 */
export const getProWorkIds = (workIds: string[]): string[] =>
    workIds.reduce((acc: string[], workId: string): string[] => {
        const proWorkIdMatch = workId.match(/-(\w+)$/);
        const proWorkId = proWorkIdMatch ? proWorkIdMatch[1] : null;

        if (proWorkId && !acc.includes(proWorkId)) {
            acc.push(proWorkId);
        }

        return acc;
    }, [] as string[]);
